import api from './api';
import { resolvePhotoUrl } from './photoUrl';
import { sha256Hex } from './sha256';

/*
 * Add a micrograph: hash the file here (the server checks the stored bytes
 * against this hash), upload it to the presigned address, then register it
 * with its links and what it shows; the server reads its metadata and scale
 * (routes/microscopy.py). An image already registered gets no upload address
 * and registering it again only adds the links. Shared by the scan station's
 * and the hub's upload (pages/scan/MicroscopyUpload.js) and the Spore
 * analysis workbench's (components/spores/SporeSources.js).
 *
 * A failed upload throws an Error with `uploadStatus` (the PUT's HTTP status).
 */
export const MICROGRAPH_TYPES = ['image/jpeg', 'image/png', 'image/tiff', 'image/bmp'];

/** The registration body's optional fields, only those with a value. */
export function registrationExtras({ structure, magnification, notes } = {}) {
  const out = {};
  if (structure) out.structure = structure;
  const mag = Number(magnification);
  if (magnification !== '' && magnification !== null && magnification !== undefined && Number.isFinite(mag) && mag > 0) {
    out.magnification = mag;
  }
  const note = typeof notes === 'string' ? notes.trim() : '';
  if (note) out.notes = note;
  return out;
}

export async function uploadMicrograph(file, { links = [], instrumentId = '', structure, magnification, notes } = {}) {
  const buffer = await file.arrayBuffer();
  const sha = await sha256Hex(buffer);
  const type = MICROGRAPH_TYPES.includes(file.type) ? file.type : 'image/jpeg';
  const { data: presigned } = await api.post('/microscopy/presign', { sha256: sha, content_type: type });
  if (!presigned.exists) {
    const put = await fetch(resolvePhotoUrl(presigned.presign_url), {
      method: 'PUT', headers: { 'Content-Type': type }, body: buffer,
    });
    if (!put.ok) throw Object.assign(new Error(`upload failed (${put.status})`), { uploadStatus: put.status });
  }
  const { data } = await api.post('/microscopy', {
    sha256: sha, s3_key: presigned.s3_key, content_type: type, links,
    ...(instrumentId ? { instrument_id: instrumentId } : {}),
    ...registrationExtras({ structure, magnification, notes }),
  });
  return data;
}
